/**
 * Created by shahar on 10-Nov-16.
 */
import {Injectable} from "@angular/core";

// class used to refer to the window element.
// in the future - we can (?!) replace the DI object by an object supporting web-workers
@Injectable()
export class WindowRef{

	public LOCAL_TAB_RESIZE="LOCAL_TAB_RESIZE";

	public dispatchLocalTabWindowResize(){
		this.dispatchWindowResize({LOCAL_TAB_RESIZE:true});
	}

	public isWindowResizeLocal(e:Event){
		return (e &&(e[this.LOCAL_TAB_RESIZE]));
	}

	public dispatchWindowResize(optParam?:any){
		let resizeEvent = new Event('resize');
		if (optParam){
			Object.assign(resizeEvent,optParam);
		}

		window.dispatchEvent(resizeEvent);
	}

	get bodyClass () {
		return document.body.className;
	}

	set bodyClass(t:string){
		document.body.className = t;
	}
}
